import { loadable } from 'utils';

export const Basic = loadable(() => import('./Basic'), {});
export const BasicExpress = loadable(() => import('./BasicExpress'), {});
export const Collection = loadable(() => import('./Collection'), {});
export const Showcase = loadable(() => import('./Showcase'), {});
export const Tag = loadable(() => import('./Tag'), {});
export const ImportWizard = loadable(() => import('./ImportWizard'), {});
